import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Collapse,
  IconButton,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
// import { fetchAlpatiaDefaultSettings } from '../../../../../containers/actions/ecosystemActions';
// import usePrevious from '../../../../pcmp/components/helpers/previousProps';
import { useDispatch, useSelector } from "react-redux";
// import { Autocomplete } from '@material-ui/lab';
// import { updateOrgProfile } from '../../../../../containers/actions/userActions';
// import BackDrop from '../../../../../components/pcmp/components/common/models/BackDrop';
// import BackDrop from '../../models/BackDrop';
import Backdrop from "@material-ui/core/Backdrop";
import { updateOrgProfile } from "../../../../../../containers/actions/userActions";
import usePrevious from "../../../helpers/previousProps";
// import { UPDATE_ORG_PROFILE } from '../../../../../../containers/actions/types';
// import { ORG_PROFILE } from '../../../../../../containers/actions/types';
import { UPDATE_ORG_PROFILE } from "../../../../../../containers/actions/types";
import { orgProfileData } from "../../../../../../containers/actions/userActions";
// import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import { UPDATE_ORG_FAIL } from '../../../../../containers/actions/types';
// import { Country, State, City } from 'country-state-city';
// import postalCodes from 'postal-codes-js';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: "#F5F9FF",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },

  content: {
    marginTop: theme.spacing(2),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  hr: {
    border: "0.5px solid #000000de",
    marginTop: "3rem",
    marginBottom: "2rem",
    width: "100%",
    borderBottom: "thick",
  },
  textfieldWidth: {
    width: "85%",
    marginTop: "8px",
  },
  hideDropdown: {
    "& .MuiAutocomplete-popupIndicator": {
      display: "none",
    },
    "& .MuiAutocomplete-clearIndicator": {
      display: "none",
    },
  },
  hideDeleteIcon: {
    "& .MuiChip-deleteIcon": {
      display: "none",
    },

    color: "#000000",
    border: "1px solid #000000",
    marginRight: "4px",
  },

  required: {
    color: "red",
    marginLeft: "4px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontWeight: 600,
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&[type=number]": {
      "-moz-appearance": "textfield",
    },
    // Additional styles to disable scrolling
    overflow: "hidden",
    pointerEvents: "none", // Prevents pointer events on the input
    touchAction: "none", // Disables touch actions
    userSelect: "none", // Disables text selection
    resize: "none", // Prevents resizing
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
}));

const EditShipmentAddressesScreen = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { openDialog, closeEditShipmentAddresses, fetchedData } = props;

  const [shipmentAddressDetails, setShipmentAddressDetails] = useState({
    DeliveryStreetAddress1: fetchedData?.delivery_address
      ? fetchedData?.delivery_address?.street_address_1
      : fetchedData?.org_address_1 || "",
    DeliveryStreetAddress2: fetchedData?.delivery_address
      ? fetchedData?.delivery_address?.street_address_2
      : fetchedData?.org_address_2 || "",
    PickupStreetAddress1: fetchedData?.pickup_address
      ? fetchedData?.pickup_address?.street_address_1
      : fetchedData?.org_address_1 || "",
    PickupStreetAddress2: fetchedData?.pickup_address
      ? fetchedData?.pickup_address?.street_address_2
      : fetchedData?.org_address_2 || "",
  });

  const [errors, setErrors] = useState({
    DeliveryStreetAddress1: "",
    DeliveryStreetAddress2: "",
    PickupStreetAddress1: "",
    PickupStreetAddress2: "",
  });

  const validateStreetAddress = (value, field) => {
    // return value.trim() === '' ? 'Street Address 1 is required' : '';
    if (value.trim() === "") {
      if (field === "DeliveryStreetAddress1")
        return "Street Address 1 is required";
      if (field === "DeliveryStreetAddress2")
        return "Street Address 2 is required";
      if (field === "PickupStreetAddress1")
        return "Street Address 1 is required";
      if (field === "PickupStreetAddress2")
        return "Street Address 2 is required";
    }
    return "";
  };

  const handleStreetAddressChange = (event, field) => {
    const value = event.target.value;
    setShipmentAddressDetails({
      ...shipmentAddressDetails,
      [field]: value,
    });
    const errorMessage = validateStreetAddress(value, field);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: errorMessage,
    }));
  };

  const didMountRef = useRef(false);

  const [updateError, setUpdateError] = useState(false);
  const [updateErrorMessage, setUpdateErrorMessage] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const orgDetails = useSelector((state) => state.user.orgDetails);

  const prevOrgDetails = usePrevious(orgDetails);
  const updateOrgFail = useSelector((state) =>
    state.user?.updateOrgDetails ? state.user.updateOrgDetails : {}
  );
  const prevUpdateOrgFail = usePrevious(updateOrgFail);
  useEffect(() => {
    if (didMountRef.current) {
      // Perform a deep comparison using isEqual from lodash

      if (JSON.stringify(updateOrgFail) !== JSON.stringify(prevUpdateOrgFail)) {
        if (updateOrgFail.status === true) {
          // setLoading(false);
          setUpdateError(false);
          setUpdateErrorMessage("");
          setOpenSuccessDialog(true);
        } else {
          // setLoading(false);
          setUpdateError(true);
          setUpdateErrorMessage(
            "Something went wrong. Please contact Alpatia Support"
          );
          setOpenSuccessDialog(false);
        }
      }
    } else {
      didMountRef.current = true;
    }
  }, [updateOrgFail, prevUpdateOrgFail]);

  const handleClose = () => {
    setOpenSuccessDialog(false);
    closeEditShipmentAddresses();
    dispatch(orgProfileData());
  };

  const handleSaveForSponsor = () => {
    // setOpen(true);

    const updatePayload = {};
    const delivery_address = {};
    const pickup_address = {};

    if (
      shipmentAddressDetails?.DeliveryStreetAddress1 !==
      fetchedData?.delivery_address?.street_address_1 || fetchedData?.org_address_1
    ) {
      delivery_address.street_address_1 =
        shipmentAddressDetails?.DeliveryStreetAddress1;
      updatePayload.delivery_address = delivery_address;
    }

    if (
      shipmentAddressDetails?.DeliveryStreetAddress2 !==
      fetchedData?.delivery_address?.street_address_2 || fetchedData?.org_address_2
    ) {
      delivery_address.street_address_2 =
        shipmentAddressDetails?.DeliveryStreetAddress2;
      updatePayload.delivery_address = delivery_address;
    }

    if (
      shipmentAddressDetails?.PickupStreetAddress1 !==
      fetchedData?.pickup_address?.street_address_1 || fetchedData?.org_address_1
    ) {
      pickup_address.street_address_1 =
        shipmentAddressDetails?.PickupStreetAddress1;
      updatePayload.pickup_address = pickup_address;
    }

    if (
      shipmentAddressDetails?.PickupStreetAddress2 !==
      fetchedData?.pickup_address?.street_address_2 || fetchedData?.org_address_2
    ) {
      pickup_address.street_address_2 =
        shipmentAddressDetails?.PickupStreetAddress2;
      updatePayload.pickup_address = pickup_address;
    }
    // updatePayload.sm_delivery_address = sm_delivery_address;
    // updatePayload.fp_pickup_address = fp_pickup_address;
    // console.log('updatePayload', updatePayload);
    dispatch(updateOrgProfile(updatePayload));
  };

  // const handleSaveForCollectionCenter = () => {
  //   // setOpen(true);

  //   const updatePayload = {};

  //   const pickup_address = {};
  //   if (
  //     shipmentAddressDetails.PickupStreetAddress1 !==
  //     fetchedData.pickup_address.street_address_1
  //   ) {
  //     pickup_address.street_address_1 =
  //       shipmentAddressDetails.PickupStreetAddress1;
  //     updatePayload.pickup_address = pickup_address;
  //   }

  //   dispatch(updateOrgProfile(updatePayload));
  // };

  // const handleSaveForTreatingHospital = () => {
  //   // setOpen(true);

  //   const updatePayload = {};
  //   const fp_delivery_address = {};
  //   if (
  //     shipmentAddressDetails.fpDeliveryStreetAddress1 !==
  //     fetchedData.fp_delivery_address.street_address_1
  //   ) {
  //     fp_delivery_address.street_address_1 =
  //       shipmentAddressDetails.fpDeliveryStreetAddress1;
  //     updatePayload.fp_delivery_address = fp_delivery_address;
  //   }
  //   if (
  //     shipmentAddressDetails.fpDeliveryStreetAddress2 !==
  //     fetchedData.fp_delivery_address.street_address_2
  //   ) {
  //     fp_delivery_address.street_address_2 =
  //       shipmentAddressDetails.fpDeliveryStreetAddress2;
  //     updatePayload.fp_delivery_address = fp_delivery_address;
  //   }

  //   dispatch(updateOrgProfile(updatePayload));
  // };

  const handleCancel = () => {
    dispatch({
      type: UPDATE_ORG_PROFILE,
      payload: {},
    });
    closeEditShipmentAddresses();
  };
  return (
    <>
      <Backdrop />
      <Dialog open={openDialog} fullScreen>
        <DialogTitle style={{ padding: "0px" }}>
          <Grid item xs={12} className={classes.header}>
            <Grid item xs={12} className={classes.titleGrid}>
              <Grid item xs={12} className={classes.head}>
                <Typography variant="h6" style={{ fontSize: "1.875rem" }}>
                  Edit Address Details
                </Typography>
                <Typography>
                  Please update the Address in the field below.
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={2} sm={2} md={2}>
              <Typography
                variant="body2"
                className={classes.closeBtn}
                onClick={handleCancel}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent
          style={{
            paddingLeft: "140px",
            paddingTop: "32px",
          }}
        >
          {updateOrgProfile?.updateFail === true && (
            <Grid
              style={{
                // paddingLeft: "150px",
                paddingTop: "8px",
                width: "87%",
                paddingBottom: "16px",
              }}
            >
              {/* {Object.keys(updatedData.errorDescription).map((key) => ( */}
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                {/* {updatedData.errorDescription[key]} */}
                {updateOrgFail.data.errorMessage}
              </Typography>
              {/* ))} */}
            </Grid>
          )}

          {/* {localStorage.collabType === 'Pharma Co' && ( */}
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.inline}>
                  Pickup Address
                </Typography>
                <hr className={classes.hrLine} />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 1 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  className={classes.textfieldWidth}
                  value={shipmentAddressDetails.PickupStreetAddress1}
                  onChange={(event) =>
                    handleStreetAddressChange(event, "PickupStreetAddress1")
                  }
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      handleStreetAddressChange({ target: { value: value.trim() } }, "PickupStreetAddress1");
                    }
                  }}
                  error={errors.PickupStreetAddress1 !== ""}
                  helperText={errors.PickupStreetAddress1}
                  onInput={(e) => {
                    e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                      .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, "")
                      .replace(
                        /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                        ""
                      );
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 2 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  className={classes.textfieldWidth}
                  value={shipmentAddressDetails.PickupStreetAddress2}
                  onChange={(event) =>
                    handleStreetAddressChange(event, "PickupStreetAddress2")
                  }
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      handleStreetAddressChange({ target: { value: value.trim() } }, "PickupStreetAddress2");
                    }
                  }}
                  error={errors.PickupStreetAddress2 !== ""}
                  helperText={errors.PickupStreetAddress2}
                  onInput={(e) => {
                    e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                      .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, "")
                      .replace(
                        /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                        ""
                      );
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  City
                </Typography>
                <Typography>{fetchedData.city}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  State
                </Typography>
                <Typography>{fetchedData.state}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Post Code
                </Typography>
                <Typography>{fetchedData.pincode}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Country
                </Typography>
                <Typography>{fetchedData.country}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={11}>
                <hr className={classes.hr} />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="body2" className={classes.inline}>
                  Delivery Address
                </Typography>
                <hr className={classes.hrLine} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 1 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  className={classes.textfieldWidth}
                  value={shipmentAddressDetails.DeliveryStreetAddress1}
                  onChange={(event) =>
                    handleStreetAddressChange(event, "DeliveryStreetAddress1")
                  }
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      handleStreetAddressChange({ target: { value: value.trim() } }, "DeliveryStreetAddress1");
                    }
                  }}
                  error={errors.DeliveryStreetAddress1 !== ""}
                  helperText={errors.DeliveryStreetAddress1}
                  onInput={(e) => {
                    e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                      .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, "")
                      .replace(
                        /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                        ""
                      );
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Street Address 2 <span className={classes.required}>*</span>
                </Typography>
                <TextField
                  size="small"
                  variant="outlined"
                  inputProps={{ maxLength: 40 }}
                  className={classes.textfieldWidth}
                  value={shipmentAddressDetails.DeliveryStreetAddress2}
                  onChange={(event) =>
                    handleStreetAddressChange(event, "DeliveryStreetAddress2")
                  }
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      handleStreetAddressChange({ target: { value: value.trim() } }, "DeliveryStreetAddress2");
                    }
                  }}
                  error={errors.DeliveryStreetAddress2 !== ""}
                  helperText={errors.DeliveryStreetAddress2}
                  onInput={(e) => {
                    e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                      .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, "")
                      .replace(
                        /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                        ""
                      );
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  City
                </Typography>
                <Typography>{fetchedData.city}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  State
                </Typography>
                <Typography>{fetchedData.state}</Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Post Code
                </Typography>
                <Typography>{fetchedData.pincode}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Country
                </Typography>
                <Typography>{fetchedData.country}</Typography>
              </Grid>
            </Grid>
          </>
          {/* )} */}

          {/* {localStorage.collabType === 'Collection Center' && (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='body2' className={classes.inline}>
                    SM Pickup Address
                  </Typography>
                  <hr className={classes.hrLine} />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Country
                  </Typography>
                  <Typography>{fetchedData.country}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    State
                  </Typography>
                  <Typography>{fetchedData.state}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    City
                  </Typography>
                  <Typography>{fetchedData.city}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Post Code
                  </Typography>
                  <Typography>{fetchedData.pincode}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 1 <span className={classes.required}>*</span>
                  </Typography>
                  <TextField
                    size='small'
                    variant='outlined'
                    inputProps={{ maxLength: 40 }}
                    className={classes.textfieldWidth}
                    value={shipmentAddressDetails.smPickupStreetAddress1}
                    onChange={(event) =>
                      handleStreetAddressChange(event, 'smPickupStreetAddress1')
                    }
                    error={errors.smPickupStreetAddress1 !== ''}
                    helperText={errors.smPickupStreetAddress1}
                    onInput={(e) => {
                      e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                        .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, '')
                        .replace(
                          /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                          ''
                        );
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 2 <span className={classes.required}>*</span>
                  </Typography>
                  <TextField
                    size='small'
                    variant='outlined'
                    inputProps={{ maxLength: 40 }}
                    className={classes.textfieldWidth}
                    value={shipmentAddressDetails.smPickupStreetAddress2}
                    onChange={(event) =>
                      handleStreetAddressChange(event, 'smPickupStreetAddress2')
                    }
                    error={errors.smPickupStreetAddress2 !== ''}
                    helperText={errors.smPickupStreetAddress2}
                    onInput={(e) => {
                      e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                        .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, '')
                        .replace(
                          /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                          ''
                        );
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )} */}

          {/* {localStorage.collabType === 'Treating Hospital' && (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography variant='body2' className={classes.inline}>
                    FP Delivery Address
                  </Typography>
                  <hr className={classes.hrLine} />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Country
                  </Typography>
                  <Typography>{fetchedData.country}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    State
                  </Typography>
                  <Typography>{fetchedData.state}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    City
                  </Typography>
                  <Typography>{fetchedData.city}</Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Post Code
                  </Typography>
                  <Typography>{fetchedData.pincode}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 1 <span className={classes.required}>*</span>
                  </Typography>
                  <TextField
                    size='small'
                    variant='outlined'
                    inputProps={{ maxLength: 40 }}
                    className={classes.textfieldWidth}
                    value={shipmentAddressDetails.fpDeliveryStreetAddress1}
                    onChange={(event) =>
                      handleStreetAddressChange(
                        event,
                        'fpDeliveryStreetAddress1'
                      )
                    }
                    error={errors.fpDeliveryStreetAddress1 !== ''}
                    helperText={errors.fpDeliveryStreetAddress1}
                    onInput={(e) => {
                      e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                        .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, '')
                        .replace(
                          /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                          ''
                        );
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                    Street Address 2 <span className={classes.required}>*</span>
                  </Typography>
                  <TextField
                    size='small'
                    variant='outlined'
                    inputProps={{ maxLength: 40 }}
                    className={classes.textfieldWidth}
                    value={shipmentAddressDetails.fpDeliveryStreetAddress2}
                    onChange={(event) =>
                      handleStreetAddressChange(
                        event,
                        'fpDeliveryStreetAddress2'
                      )
                    }
                    error={errors.fpDeliveryStreetAddress2 !== ''}
                    helperText={errors.fpDeliveryStreetAddress2}
                    onInput={(e) => {
                      e.target.value = e.target.value // Allow only letters, digits, spaces, commas, periods, hyphens, apostrophes, slashes, and number signs
                        .replace(/[^a-zA-Z0-9\s,.\-'/#]/g, '')
                        .replace(
                          /(\s{2,}|,{2,}|\.{2,}|-{2,}|'{2,}|\/{2,}|#{2,})/g,
                          ''
                        );
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )} */}

          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              style={{ paddingTop: "24px", paddingBottom: "24px" }}
            >
              <Typography>
                <span style={{ fontWeight: "500" }}>Note: </span>All fields
                marked with an asterisk (<span style={{ color: "red" }}>*</span>
                ) are mandatory.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: "20px",
                  textTransform: "none",
                  marginRight: "7rem",
                }}
                onClick={handleSaveForSponsor}
                disabled={
                  [
                    "DeliveryStreetAddress1",
                    "DeliveryStreetAddress2",
                    "PickupStreetAddress1",
                    "PickupStreetAddress2",
                  ].some((field) => shipmentAddressDetails[field] === "") ||
                  [
                    "DeliveryStreetAddress1",
                    "DeliveryStreetAddress2",
                    "PickupStreetAddress1",
                    "PickupStreetAddress2",
                  ].some((field) => errors[field] !== "") ||
                  (shipmentAddressDetails?.DeliveryStreetAddress1 ===
                   ( fetchedData?.delivery_address?.street_address_1 || fetchedData?.org_address_1) &&
                    shipmentAddressDetails?.DeliveryStreetAddress2 ===
                   (fetchedData?.delivery_address?.street_address_2 || fetchedData?.org_address_2) &&
                    shipmentAddressDetails?.PickupStreetAddress1 ===
                      (fetchedData?.pickup_address?.street_address_1 || fetchedData?.org_address_1) &&
                    shipmentAddressDetails?.PickupStreetAddress2 ===
                      (fetchedData?.pickup_address?.street_address_2 || fetchedData?.org_address_2))
                }
              >
                Update
              </Button>

              {/* {localStorage.collabType === 'Sponsor' ? (
                <Button
                  variant='contained'
                  color='primary'
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: '20px',
                    textTransform: 'none',
                    marginRight: '7rem',
                  }}
                  onClick={handleSaveForSponsor}
                  disabled={
                    [
                      'smDeliveryStreetAddress1',
                      'smDeliveryStreetAddress2',
                      'fpPickupStreetAddress1',
                      'fpPickupStreetAddress2',
                    ].some((field) => shipmentAddressDetails[field] === '') ||
                    [
                      'smDeliveryStreetAddress1',
                      'smDeliveryStreetAddress2',
                      'fpPickupStreetAddress1',
                      'fpPickupStreetAddress2',
                    ].some((field) => errors[field] !== '') ||
                    (shipmentAddressDetails.smDeliveryStreetAddress1 ===
                      fetchedData.sm_delivery_address.street_address_1 &&
                      shipmentAddressDetails.smDeliveryStreetAddress2 ===
                        fetchedData.sm_delivery_address.street_address_2 &&
                      shipmentAddressDetails.fpPickupStreetAddress1 ===
                        fetchedData.fp_pickup_address.street_address_1 &&
                      shipmentAddressDetails.fpPickupStreetAddress2 ===
                        fetchedData.fp_pickup_address.street_address_2)
                  }
                >
                  Update
                </Button>
              ) : localStorage.collabType === 'Collection Center' ? (
                <Button
                  variant='contained'
                  color='primary'
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: '20px',
                    textTransform: 'none',
                    marginRight: '7rem',
                  }}
                  onClick={handleSaveForCollectionCenter}
                  disabled={
                    ['smPickupStreetAddress1', 'smPickupStreetAddress2'].some(
                      (field) => shipmentAddressDetails[field] === ''
                    ) ||
                    ['smPickupStreetAddress1', 'smPickupStreetAddress2'].some(
                      (field) => errors[field] !== ''
                    ) ||
                    (shipmentAddressDetails.smPickupStreetAddress1 ===
                      fetchedData.sm_pickup_address.street_address_1 &&
                      shipmentAddressDetails.smPickupStreetAddress2 ===
                        fetchedData.sm_pickup_address.street_address_1)
                  }
                >
                  Update
                </Button>
              ) : localStorage.collabType === 'Treating Hospital' ? (
                <Button
                  variant='contained'
                  color='primary'
                  endIcon={<ChevronRight />}
                  style={{
                    borderRadius: '20px',
                    textTransform: 'none',
                    marginRight: '7rem',
                  }}
                  onClick={handleSaveForTreatingHospital}
                  disabled={
                    [
                      'fpDeliveryStreetAddress1',
                      'fpDeliveryStreetAddress2',
                    ].some((field) => shipmentAddressDetails[field] === '') ||
                    [
                      'fpDeliveryStreetAddress1',
                      'fpDeliveryStreetAddress2',
                    ].some((field) => errors[field] !== '') ||
                    (shipmentAddressDetails.fpDeliveryStreetAddress1 ===
                      fetchedData.fp_delivery_address.street_address_1 &&
                      shipmentAddressDetails.fpDeliveryStreetAddress2 ===
                        fetchedData.fp_delivery_address.street_address_2)
                  }
                >
                  Update
                </Button>
              ) : (
                ''
              )} */}
            </Grid>
          </Grid>
        </DialogContent>

        <Dialog open={openSuccessDialog} maxWidth="sm" fullWidth>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.avatar} />

            <Typography variant="h6" style={{ marginTop: "10px" }}>
              Shipment addresses saved
            </Typography>
            <Typography variant="body1" style={{ marginTop: "10px" }}>
              The shipment address have been updated successfully.
            </Typography>

            <DialogActions className={classes.dialogActions}>
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: "20px",
                  textTransform: "none",
                }}
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Dialog>
    </>
  );
};

export default EditShipmentAddressesScreen;
